import { render, staticRenderFns } from "./ShareChooseDialog.vue?vue&type=template&id=554128f0&scoped=true&"
import script from "./ShareChooseDialog.vue?vue&type=script&lang=js&"
export * from "./ShareChooseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareChooseDialog.vue?vue&type=style&index=0&id=554128f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554128f0",
  null
  
)

export default component.exports